import { HTTP_STATUS } from '../response';

export interface ChangeEmailRequest {
	password: string;
	newEmail: string;
}

export enum ChangeEmailError {
	Unauthorized = 'Unauthorized',
	EmailInvalid = 'EmailInvalid',
	EmailDuplicate = 'EmailDuplicate',
	EmailChangeActive = 'EmailChangeActive',
	EmailConcurrent = 'EmailConcurrent',
	InternalError = 'InternalError'
}

export interface ChangeEmailSuccessResponse {
	status: HTTP_STATUS;
}

export interface ChangeEmailErrorResponse {
	status: HTTP_STATUS;
	error?: ChangeEmailError;
}

export type ChangeEmailResponse = ChangeEmailSuccessResponse | ChangeEmailErrorResponse;

export type EmailChangeAction = (
	request: ChangeEmailRequest,
) => Promise<ChangeEmailResponse>;
